import { FC, useCallback } from "react";
import { useAppDispatch } from "@/store/hooks";
import { billingExplorerInheritanceChangeThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/setup-change/billingExplorerInheritanceChangeThunk";
import { WidgetSetupDateRangeWithInheritance } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/date-range/WidgetSetupDateRangeWithInheritance";
import { Dates } from "@/services/cloudchipr.api";
import { billingExplorerDateRangeChangeThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/setup-change/billingExplorerDateRangeChangeThunk";
import { billingExplorerViewVisualizationChangeThunk } from "@/store/dashboards/thunks/widgets/billing-explorer-widget/setup-change/billingExplorerViewVisualizationChangeThunk";
import { WidgetSetupDateRangeSelect } from "@/components/pages/dashboard/components/adding-widget/widget-create/widget-setups/common/toolbar/WidgetSetupDateRangeSelect";

export const BillingExplorerWidgetSetupDateRange: FC = () => {
  const dispatch = useAppDispatch();

  const syncWithDashboardHandler = useCallback(
    (checked: boolean) => {
      dispatch(billingExplorerInheritanceChangeThunk(checked));
    },
    [dispatch],
  );

  const dateRangeChangeHandler = useCallback(
    (dates: Dates) => {
      dispatch(billingExplorerDateRangeChangeThunk(dates));
      if (
        dates.label !== "month_to_date" &&
        dates.label !== "quarter_to_date"
      ) {
        dispatch(
          billingExplorerViewVisualizationChangeThunk({
            display_forecast: false,
          }),
        );
      }
    },
    [dispatch],
  );

  return (
    <WidgetSetupDateRangeWithInheritance onChange={syncWithDashboardHandler}>
      <WidgetSetupDateRangeSelect onDateChange={dateRangeChangeHandler} />
    </WidgetSetupDateRangeWithInheritance>
  );
};
